import { fromJS } from 'immutable';

import { addToast } from '@sophocles/features/toast';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

export function fetchSiteGroupInstruction(siteGroupInstruction_id) {
  return dispatch =>
    apiClient
      .get(`/sitegroupinstructions/${siteGroupInstruction_id}/`)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data))
      .catch(error => {
        dispatch(genericErrorAction(error, 'REQUEST_SITE_GROUP_INSTRUCTION'));
      });
}

export function fetchSiteGroupInstructionsForSiteGroup(siteGroup) {
  return dispatch =>
    apiClient
      .get(`/sitegroupinstructions/?site_group=${siteGroup}`)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data.results))
      .catch(error => {
        dispatch(genericErrorAction(error, 'REQUEST_SITE_GROUP_INSTRUCTIONS_FOR_SITE_GROUP'));
      });
}

export function fetchSiteGroupInstructionsForSiteGroupWithTypes(siteGroup, types) {
  return dispatch => {
    const typesString = types.join(',');
    return apiClient
      .get(`/sitegroupinstructions/?site_group=${siteGroup}&applies_to__in=${typesString}`)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data.results))
      .catch(error => dispatch(genericErrorAction(error, 'REQUEST_SITE_GROUP_INSTRUCTIONS_FOR_SITE_GROUP')));
  };
}

export function patchSiteGroupInstruction(siteGroupInstruction_id, values) {
  return dispatch =>
    apiClient
      .patch(`/sitegroupinstructions/${siteGroupInstruction_id}/`, values)
      .then(checkHttpStatus)
      .then(response => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Special instruction updated',
            level: 'success',
            dismissible: true,
          }),
        );
        return fromJS(response.data);
      })
      .catch(error => {
        dispatch(genericErrorAction(error, 'EDIT_SITE_GROUP_INSTRUCTION'));
      });
}

export function createSiteGroupInstruction(values) {
  return dispatch =>
    apiClient
      .post(`/sitegroupinstructions/`, values)
      .then(checkHttpStatus)
      .then(response => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Special instruction created',
            level: 'success',
            dismissible: true,
          }),
        );
        return fromJS(response.data);
      })
      .catch(error => {
        dispatch(genericErrorAction(error, 'CREATE_SITE_GROUP_INSTRUCTION'));
      });
}

export function deleteSiteGroupInstruction(siteGroupInstruction_id) {
  return dispatch =>
    apiClient
      .delete(`/sitegroupinstructions/${siteGroupInstruction_id}/`)
      .then(checkHttpStatus)
      .then(response => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Special instruction deleted',
            level: 'success',
            dismissible: true,
          }),
        );
        return { success: true };
      })
      .catch(error => {
        dispatch(genericErrorAction(error, 'DELETE_SITE_GROUP_INSTRUCTION'));
      });
}
